import * as React from 'react';
import { useTranslation } from 'react-i18next';
import WarningBanner from './WarningBanner';

type Props = {
  showBanner: boolean;
};

export const DeutschlandTicketIgnoredBanner: React.FC<Props> = ({ showBanner }) => {
  const { t } = useTranslation();

  if (showBanner) {
    return (
      <WarningBanner
        type='warning'
        title={t('deutschlandTicketIgnoredBanner.title')}
        label={t('deutschlandTicketIgnoredBanner.label')}
      />
    );
  }
};
